'use strict';

var isBefore = require('date-fns/is_before');
var isAfter = require('date-fns/is_after');
var addMonths = require('date-fns/add_months');
var isToday = require('date-fns/is_today');

var conditionIsSatisfied = function conditionIsSatisfied(condition, parent) {
	switch (condition.parentType) {
		case 'text':
		case 'textArea':
			if (getEqualityByComparator((parent.value !== undefined && typeof parent.value === "string" ? parent.value : '').trim().length, 0, condition.comparator)) return false;
			break;
		case 'checkbox':
			var parentValue = parent.value === true || parent.value === 'true' ? true : false;
			var conditionValue = condition.value === true || condition.value === 'true' ? true : false;
			if (getEqualityByComparator(parentValue, conditionValue, condition.comparator)) return false;
			break;
		case 'select':
		case 'radio':
		case 'dependentSelect':
		case 'dependentRadio':
		case 'serverSelect':
		case 'serverRadio':
		case 'date':
			if (getEqualityByComparator(parent.value, condition.value, condition.comparator)) return false;
			break;
		case 'EntityNameSearch':
			switch (condition.subFieldId) {
				case 'reservedYN':
					if (!parent.hideReserved) {
						if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
					} else return false;
					break;
				case 'additionalYN':
					if ((parent.value.reservedYN === 'N' || parent.hideReserved) && !parent.hideAdditionalName) {
						if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
					} else return false;
					break;
				case 'consentYN':
					if ((parent.value.reservedYN === 'N' || parent.hideReserved) && (parent.value.additionalYN === 'N' || parent.hideAdditionalName) && !parent.hideConsent) {
						if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
					} else return false;
					break;
				case 'requireSupportingDocument':
					if (getEqualityByComparator(parent.requireSupportingDocument, condition.value, condition.comparator)) return false;
					break;
			}
			break;
		case 'NameQualifiedOrg':
			if (getEqualityByComparator(((parent.value || {}).ORG_TYPE || "").toString(), condition.value.toString(), condition.comparator)) return false;
			break;
		case 'UploadAndSubmit':
			if (getEqualityByComparator((parent.value || {}).method, condition.value, condition.comparator)) return false;
			break;
		case 'registeredAgentSearch':
			if (getEqualityByComparator(((parent.value || {}).TYPE_ID || "").toString(), condition.value.toString(), condition.comparator)) return false;
			break;
		case 'addressBlock':
			if (getEqualityByComparator((parent.value || {}).STATE || "", condition.value, condition.comparator)) return false;
			break;
	}
	return true;
};

var getEqualityByComparator = function getEqualityByComparator(left, right) {
	var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';

	switch (comparator) {
		case '!=':
			return left === right;
		case '<p':
			if (!left) return true;

			var date = new Date(left);

			if (isToday(date)) return false;
			if (isAfter(new Date(), date)) return true;

			switch (right) {
				case '6m':
				default:
					return !isBefore(date, addMonths(new Date(), 6));
			}
		case '=':
		default:
			return left !== right;
	}
};

var resolveFieldConditions = function resolveFieldConditions(conditions, fields) {
	var operator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'and';

	if (conditions) {
		for (var i = 0; i < conditions.length; i++) {
			var condition = conditions[i];
			var parent = fields[condition.parentId];
			if (condition.parentId !== '' && parent) {
				if (operator === 'or') {
					var parentConditions = fields[condition.parentId].conditions;
					var parentConditionsSatisfied = parentConditions ? resolveFieldConditions(parentConditions, fields, fields[condition.parentId].conditionsOperator) : true;
					var satisfied = conditionIsSatisfied(condition, parent);
					if (satisfied && parentConditionsSatisfied) return true;
				} else {
					var _parentConditions = fields[condition.parentId].conditions;
					var _parentConditionsSatisfied = _parentConditions ? resolveFieldConditions(_parentConditions, fields, fields[condition.parentId].conditionsOperator) : true;
					if (!_parentConditionsSatisfied) return false;
					if (!conditionIsSatisfied(condition, parent)) return false;
				}
			}
		}
		if (operator === 'and') {
			return true;
		} else {
			return false;
		}
	}
	return true;
};

exports.resolveFieldConditions = resolveFieldConditions;



//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/wizard-utilities/build/index.js
// module id = 66
// module chunks = 0